var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayLarge = function SvgPlayLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 28.632c.049 2.118 2.239 3.401 4.158 2.393l15.431-8.675c.84-.473 1.411-1.34 1.411-2.355 0-1.016-.57-1.883-1.41-2.356L15.157 8.977c-1.919-1.008-4.11.262-4.158 2.38z"
  })));
};
export default SvgPlayLarge;